import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Callback = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Check authentication after OAuth callback
        await checkAuth();
        
        // Redirect to chat
        setTimeout(() => {
          navigate('/chat');
        }, 1000);
      } catch (error) {
        console.error('Callback error:', error);
        navigate('/login');
      }
    };

    handleCallback();
  }, [checkAuth, navigate]);

  return (
    <div className="callback-container">
      <div className="callback-content">
        <div className="loading-spinner"></div>
        <h2>Completing sign in...</h2>
        <p>Please wait while we authenticate your account.</p>
      </div>
    </div>
  );
};

export default Callback;